/**
 * Máscaras simples no formato do jQuery Mask da tela antiga:
 * 0 = dígito; os demais caracteres são fixos.
 */
export function applyMask(value, pattern) {
    const digits = value.replace(/\D/g, '');
    let out = '';
    let i = 0;
    for (const ch of pattern) {
        if (i >= digits.length)
            break;
        if (ch === '0')
            out += digits[i++];
        else
            out += ch;
    }
    return out;
}
export const maskCpf = (value) => applyMask(value, '000.000.000-00');
export const maskPhone = (value) => applyMask(value, '(00) 0 0000-0000');
